import { type Static, Type } from "@sinclair/typebox";
import { DocumentKind, DriverProfileView } from "./driver.ts";

/**
 * Cadastro de motorista pelo site (ichegoubr.com/motorista/cadastro). The phone or the CPF finds a
 * registration, but only a code sent to the phone opens it: the answers never say whether either is
 * known. Once open, the site saves through the same `/driver/onboarding/*` routes as the apps.
 */
export const REGISTRATION_STEPS = ["phone_code", "personal", "address", "vehicle", "documents", "payout", "review", "submitted", "already_driver"] as const;
export type RegistrationStep = (typeof REGISTRATION_STEPS)[number];

export const CodeChannel = Type.Union([Type.Literal("sms"), Type.Literal("whatsapp")]);

export const RegistrationStart = Type.Object({
  phoneNumber: Type.String({ maxLength: 30 }),
  email: Type.String({ maxLength: 254 }),
  channel: Type.Optional(CodeChannel),
});
export type RegistrationStart = Static<typeof RegistrationStart>;

/** Exactly one of them: the code goes to the phone on the registration. */
const Finder = { phoneNumber: Type.Optional(Type.String({ maxLength: 30 })), cpf: Type.Optional(Type.String({ maxLength: 20 })) };

export const RegistrationResume = Type.Object({ ...Finder, channel: Type.Optional(CodeChannel) });
export type RegistrationResume = Static<typeof RegistrationResume>;

export const RegistrationVerify = Type.Object({ ...Finder, code: Type.String({ minLength: 4, maxLength: 8 }) });
export type RegistrationVerify = Static<typeof RegistrationVerify>;

export const RegistrationUnsubscribe = Type.Object({ token: Type.String({ minLength: 16, maxLength: 128 }) });

export const RegistrationState = Type.Object({
  step: Type.Union([
    Type.Literal("phone_code"), Type.Literal("personal"), Type.Literal("address"), Type.Literal("vehicle"), Type.Literal("documents"),
    Type.Literal("payout"), Type.Literal("review"), Type.Literal("submitted"), Type.Literal("already_driver"),
  ]),
  /** "(11) •••••-4321". */
  phone: Type.String(),
  email: Type.String(),
  /** The documents this cadastro needs under the current config, in the order the form asks for them. */
  requiredDocuments: Type.Array(DocumentKind),
  profile: DriverProfileView,
});
export type RegistrationState = Static<typeof RegistrationState>;

export const RegistrationVerified = Type.Object({ token: Type.String(), registration: RegistrationState });
